import store from "@/store";
export const stagePermission = function (el, binding) {
  const userDetail = store.state.user.studentUserInfo;
  const shouldShow = userDetail && userDetail.stage !== "意向学员";

  if (!shouldShow) {
    el.style.display = "none";
  } else {
    el.style.display = "";
  }
};
export const stagePermission2 = function (el, binding) {
  const userDetail = store.state.user.studentUserInfo;
  const shouldShow = userDetail && userDetail.stage === "在学学员";

  if (!shouldShow) {
    el.style.display = "none";
  } else {
    el.style.display = "";
  }
};
export const stagePermission3 = function (el, binding) {
  const userDetail = store.state.user.studentUserInfo;
  const shouldShow = userDetail && userDetail.stage === "结业学员";

  if (!shouldShow) {
    el.style.display = "none";
  } else {
    el.style.display = "";
  }
};
export default stagePermission;
